import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "page-settings" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Page Settings", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "darkmode" }, "Darkmode", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "🍪 Cookie Settings", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "italic",
  style: {"font-size":"0.8em"}
}, "No settings here yet. Only functional cookies that cannot be turned off.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      name: "darkmode",
      id: "darkmode",
      class: "toggle",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSettings.darkMode) = $event))
    }, null, 512), [
      [_vModelCheckbox, _ctx.pageSettings.darkMode]
    ]),
    _hoisted_4,
    _hoisted_5
  ]))
}